import React, { useState, useEffect } from "react";
import { Navbar } from "components/navbar";
import { Footer } from "components/footer";
import { useNavigate } from "react-router-dom";
import { Notification } from "components/notification";
import { useAuth } from "hooks/useAuth";
export const Layout = ({ children }) => {
  const { notification, hideNotification } = useAuth();
  const navigate = useNavigate();

  const handleLoginClick = () => {
    navigate("/sign-in");
  };

  return (
    <>
      <Navbar handleLoginClick={handleLoginClick} />
      {notification && (
        <Notification
          message={notification.message}
          type={notification.type}
          onClose={hideNotification}
        />
      )}
      {children}
      <Footer />
    </>
  );
};
